import React from 'react';

const Pratical = () => {
  return (
    <div id='pricing' className="pricing" >
      <div className="dots dots-up"></div>
      <div className="dots dots-down"></div>
      <h2 className="main-title">About Us</h2>
      <div className="container" >
        <div className="box popular">
          <div className="label">About us</div>
          <div className="title">
            <p className='heading box-title' >Experience Background</p>
          </div>
          <img src="imgs/Mohamed abi.png" alt="" />
          <div className="price">
            <span className="into">
              <p>
              Hello, I'm Mohamed Abi, a passionate and dedicated student who has successfully completed my undergraduate studies, majoring in Software Engineering. I've recently embarked on a new academic journey in the field of Data Science, and I'm currently in my first year of specialization.</p>
              
              <p> In addition to my academic pursuits, I actively engage as a freelance web developer,My expertise lies in web development, where I've honed my skills with a strong foundation in various programming languages, frameworks, and technologies.
                 I've had the privilege of working with clients from the USA and have used a range of tools, including Oracle APEX, Node.js, Express.js, and MongoD  to create this  portfolio plus wordpress. 
                 
              </p>
              <p>Currently, I'm expanding my horizons by delving into technologies like Tailwind CSS and Next.js.

My journey in the world of technology has been characterized by a relentless pursuit of creating innovative and user-friendly web experiences. I'm deeply committed to continuous self-improvement and staying abreast of the latest industry trends. Moreover, I'm actively learning statistics and algorithms crucial for my Data Science specialization.
              </p>
            </span>
          </div>

          <p>
            Web development is my true passion, and I find joy in crafting elegant and functional websites that make a positive impact. Throughout my academic journey, I have gained a solid understanding of software engineering principles, algorithms, and data structures, which allows me to approach web development projects with a strong technical foundation.
          </p>

          <h2>Skills and Expertise</h2>
          <ul className='our-skills'>
            <li>Front-end Development: Proficient in HTML5, CSS3,Bootstrap, JavaScript, and modern front-end frameworks such as React.js.(working on Next js) Experienced in building responsive and accessible web interfaces using best practices.</li>
            <li>Back-end Development: Knowledge of server-side technologies like Node.js and Express.js or Django , with a focus on creating robust and efficient RESTful APIs. Familiarity with databases such as MongoDB and MySQL for data modeling and management.</li>
            <li>Full Stack Development: Comfortable working on both front-end and back-end aspects of web applications, ensuring seamless integration and optimal performance.</li>
            <li>Version Control: Experienced in using Git and GitHub for collaborative development, version control, and project management.</li>
            <li>Problem Solving: Strong analytical and problem-solving skills, coupled with the ability to break down complex problems into manageable components and propose effective solutions.</li>
          </ul>
          {/* <a href="#our-skills">Skills</a> */}
        </div>
      </div>
    </div>
  );
};

export default Pratical;
